import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { DropDownItem } from "./dropdown.item";

@Component({
    selector: 'dropdown',
    templateUrl: 'dropdown.html'
  })
export class DropDown<T> {

    isOpen: boolean = false;
    selectedItem: DropDownItem<T>;
    defaultItem: DropDownItem<T>;
    
    @ViewChild('dropdown') elementRef: ElementRef;
    @Input() items: DropDownItem<T>[];
    @Output() onSelect:EventEmitter<DropDownItem<T>> = new EventEmitter();
    
    get selectedItemText(): String {
        let item = this.selectedItem;

        if (!item) {
            if (this.defaultItem) {
                item = this.defaultItem;
            } else if (this.items && this.items.length > 0) {
                item = this.items[0];
            }
        }

        if (item) {
            return item.text;
        } else {
            return "";
        }
    }

    open(event?: UIEvent) {        
        this.isOpen = true;
    }

    close(event?: UIEvent) {
        this.isOpen = false;
    }

    toggle(event?: UIEvent) {
        if (this.isOpen) {
            this.close(event);
        } else {
            this.open(event);
        }
        
    }

    onItemClick(item: DropDownItem<T>) {
        this.selectedItem = item;
        if (this.onSelect) {
            this.onSelect.emit(item);
        }
    }

    setItems(items: DropDownItem<T>[]) {
        this.items = items;
    }


}


// WEBPACK FOOTER //
// ./src/app/components/tx-ui-inner-3/dropdown/dropdown.ts